import React from 'react'
import './Heading.css'
import classNames from 'classnames'

const Heading = ({ level = '1', text = '', ...props }) => {
  let Heading = `h${level}`

  let classes = classNames({
    'Heading': true,
    'circular-bold': true
  })

  return (
    <Heading className={classes} {...props}>
      {text}
    </Heading>
  )
}

export default Heading



// WEBPACK FOOTER //
// ./src/Components/Heading/Heading.js